import { render, staticRenderFns } from "./QaReply.vue?vue&type=template&id=43a407c6&scoped=true&"
import script from "./QaReply.vue?vue&type=script&lang=js&"
export * from "./QaReply.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43a407c6",
  null
  
)

export default component.exports